var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrown = function SvgCrown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1",
    width: 24,
    height: 20,
    fill: "#000",
    viewBox: "-4 0 24.16 20.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M8.07 5.132a2.507 2.507 0 0 1-2.5-2.5c0-1.406 1.125-2.5 2.5-2.5s2.5 1.094 2.5 2.5c0 1.375-1.125 2.5-2.5 2.5M-1.899 4.1c1.094 0 1.97.906 1.97 2 0 1.125-.876 2-1.97 2-1.125 0-2.03-.875-2.03-2 0-1.094.905-2 2.03-2m20 0c1.094 0 1.97.906 1.97 2 0 1.125-.876 2-1.97 2-1.125 0-2.03-.875-2.03-2 0-1.094.905-2 2.03-2M.29 17.913-1.367 8.85c.5-.094.97-.375 1.344-.688 1.031.938 2.344 1.844 3.594 1.844 1.5 0 2.72-2.313 3.563-4.25.281.094.625.188.938.188s.656-.094.938-.188c.844 1.938 2.063 4.25 3.563 4.25 1.25 0 2.563-.906 3.594-1.844.375.313.844.594 1.344.688l-1.656 9.063H.292zm-.344.78h16.25v1.532H-.055z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrown);
export default ForwardRef;